import React from 'react'
import { GatsbyImage, IGatsbyImageData, getImage } from 'gatsby-plugin-image'
import { IImage } from './types'

const Image = ({ file, gatsbyImageData, description, imageStyles }: IImage) => {
  const imageContentTypes = ['image/gif', 'image/svg+xml', 'image/png', 'image/jpg', 'image/jpeg']

  if (file?.contentType && imageContentTypes.includes(file.contentType)) {
    return <img style={{ maxWidth: '100%', ...imageStyles }} src={file?.url || ''} alt={description || ''}></img>
  }

  return (
    <GatsbyImage
      style={imageStyles || {}}
      image={getImage(gatsbyImageData!) as IGatsbyImageData}
      alt={description || ''}
    />
  )
}

export default Image
